<template>
	<v-col cols="12">
		<v-card class="pa-4" outlined>
			<div class="text-h5 mb-4">Delivery address</div>
			<div class="mb-2" v-if="address">
				<span class="black--text">{{ address.name }}</span><br>
				<span class="black--text">{{ address.street }}</span><br>
				<span class="black--text mr-1">{{ address.postal_code }}</span>
				<span class="black--text">{{ address.city }}</span><br>
				<span class="black--text">{{ address.country.name }}</span>
				<span v-if="address.state" class="black--text">,
					{{ address.state.name }}
				</span>
				<br>
			</div>
			<v-alert v-else type="error">
				Select an delivery address!
			</v-alert>

			<v-dialog v-model="dialog" max-width="600px">
				<template v-slot:activator="{ on }">
					<v-btn
						color="blue"
						text
						class="white--text mt-2"
						v-on="on"
						@click="dialogChangeAddress"
					>
						Change delivery address
					</v-btn>
				</template>
				<v-card>
					<v-card-title class="text-h5 text-md-h4 font-weight-400 mb-2 d-flex align-center">
						<div>Saved delivery addresses</div>
						<v-spacer/>
						<div class="" @click="dialog = false">
							<v-btn
								icon
								text
							>
								<v-icon size="18">mdi-close</v-icon>
							</v-btn>
						</div>
					</v-card-title>
					<v-card-text>
						<v-item-group v-model="newAddressIndex" mandatory>
							<v-row>
								<v-col
									v-for="(address, index) in items"
									:key="index"
									cols="12"
								>
									<v-item v-slot="{ active }">
										<div
											@click="changeAddress(address)"
											class="border-1s w-100 px-2 py-4 cursor--pointer"
											:class="{'border--primary border-2s':active}"
										>
											<span class="black--text">{{ address.name }}</span><br>
											<span class="black--text">{{ address.street }}</span><br>
											<span class="black--text mr-1">{{ address.postal_code }}</span>
											<span class="black--text">{{ address.city }}</span><br>
											<span class="black--text">{{ address.country.name }}</span>
											<span v-if="address.state" class="black--text">,
												{{ address.state.name }}
											</span>
											<br>
										</div>
									</v-item>
								</v-col>
							</v-row>
						</v-item-group>
					</v-card-text>
					<v-card-actions class="">
						<v-btn
							color="primary"
							text
							block
							class="white--text mb-2"
							@click="moveToProfile()"
						>
							Edit/add delivery addresses
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-card>
	</v-col>

</template>
<script>

export default {
	name: 'BlockAddress',
	components: {},
	computed: {
		items() {
			return this.$store.getters['BASKET_STORE/ADDRESSES'];
		},
		selected() {
			return this.$store.getters['BASKET_STORE/DATA'].address;
		},
		address() {
			return this.items.find(item => item.id === this.selected) ?? null;
		},
	},
	data: () => ({
		dialog: false,
		newAddressIndex: null,
	}),
	methods: {
		dialogChangeAddress() {
			this.newAddressIndex = this.items.findIndex(i => i.id === this.selected);
		},
		changeAddress(address) {
			this.$store.commit('BASKET_STORE/DATA_SET', {
				name: 'address',
				value: address.id
			});
			this.dialog = false;
		},
		moveToProfile() {
			this.$store.commit('PROFILE_CLIENT_STORE/MOVE_TO_SET', 'address');

			this.$router.push({name: 'ProfileIndex'});
		},
	},
	created() {
	}
};
</script>
